import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, FlaskConical } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export const PromptPreview = ({ prompt }) => {
  const [scenario, setScenario] = useState("");
  const [result, setResult] = useState(null);
  const [running, setRunning] = useState(false);

  const tryIt = async () => {
    if (prompt.trim().length < 20) return toast.error("Write the prompt first, then try it");
    setRunning(true);
    try {
      const { data } = await api.post("/admin/inquiry-prompts/preview", { prompt, scenario });
      setResult(data);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Preview failed");
    } finally {
      setRunning(false);
    }
  };

  return (
    <div className="border border-[#007AFF]/30 bg-[#007AFF]/5 p-4" data-testid="prompt-preview">
      <div className="flex items-start justify-between gap-3 mb-2">
        <div>
          <Label className="text-xs uppercase tracking-[0.2em] font-bold text-[#007AFF] flex items-center gap-2">
            <FlaskConical className="w-3.5 h-3.5" /> Try it before going live
          </Label>
          <p className="text-[11px] text-muted-foreground mt-1">
            Drafts a sample email with the prompt exactly as written above. Nothing is saved or sent.
          </p>
        </div>
        <Button type="button" size="sm" variant="outline" onClick={tryIt} disabled={running} data-testid="prompt-try-btn"
          className="rounded-sm gap-1.5 h-8 text-xs border-[#007AFF]/50 text-[#007AFF] hover:bg-[#007AFF]/10 hover:text-[#007AFF] shrink-0">
          {running ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <FlaskConical className="w-3.5 h-3.5" />}
          {running ? "Drafting…" : "Try it"}
        </Button>
      </div>
      <Textarea value={scenario} onChange={(e) => setScenario(e.target.value)} rows={2} data-testid="prompt-scenario-input"
        placeholder="Optional: describe a test scenario. Leave blank to use the built-in short-delivery sample."
        className="bg-background border-border rounded-sm text-xs resize-y focus-visible:ring-[#007AFF]" />
      {result && (
        <div className="mt-3" data-testid="prompt-preview-result">
          <p className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground mb-1">Sample draft</p>
          <pre className="text-xs leading-relaxed whitespace-pre-wrap font-sans border border-border bg-background p-3 max-h-72 overflow-y-auto">{result.draft}</pre>
        </div>
      )}
    </div>
  );
};
